var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Loading',{attrs:{"loading":_vm.loading}}),(!_vm.loading)?_c('span',[_c('SimulationShowHeader',{attrs:{"simulation":_vm.simulation}}),_c('SimulationProductionsCard',{attrs:{"simulation":_vm.simulation},on:{"updated":_vm.getSimulation}}),_c('SimulationGraphicCards',{attrs:{"simulation":_vm.simulation}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }